import React, { useCallback, useEffect, useState } from 'react';
import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { getDealerLocatorService } from '@yme/components/DealerLocator/redux/services';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getCurrentCountryRoot, getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { getIsSearchedPlaceEmpty, getMyLocation, getReadableSearchedPlace, } from '../ShippingDetailsForm/PreferredDealer/GoogleLocationSearch/redux/selectors';
import { setActivePreferDealerId } from '../redux/actions';
import { getFilteredDealerList, getGoogleKey, getActivePreferDealerId } from '../redux/selectors';
import { MapModalDesktop } from './desktop/MapModal';
import { getIsOnlyCachedDealer } from './helpers';
import { MapModalMobile } from './mobile/MapModal';
export function MapModal() {
    const dispatch = useDispatch();
    const isRightToLeft = useSelector(getRTL);
    const { language } = useTranslation();
    const dealers = useSelector(getFilteredDealerList);
    const activePreferDealerId = useSelector(getActivePreferDealerId);
    const currentCountry = useSelector(getCurrentCountryRoot);
    const isSearchedPlaceEmpty = useSelector(getIsSearchedPlaceEmpty);
    const searchInitialValue = useSelector(getReadableSearchedPlace);
    const myLocation = useSelector(getMyLocation);
    const googleApiKey = useSelector(getGoogleKey);
    const { isInfiniteDesktopView: isDesktop } = useWindowSize();
    const [selectedDealerId, setSelectedDealerId] = useState(null);
    const isOnlyCachedDealer = getIsOnlyCachedDealer(dealers);
    // fetch dealers if there are no dealers OR there is ONLY cached dealer
    useEffect(() => {
        if (isEmpty(dealers) || (isSearchedPlaceEmpty && isOnlyCachedDealer)) {
            getDealerLocatorService({
                country: currentCountry,
                language,
                dispatch,
            });
        }
    }, [currentCountry, dealers, dispatch, isOnlyCachedDealer, isSearchedPlaceEmpty, language]);
    const submitDealer = useCallback((vicinityId) => {
        dispatch(setActivePreferDealerId({
            vicinityId,
        }));
    }, [dispatch]);
    const handleMapInfoWindowDismiss = useCallback(() => {
        setSelectedDealerId(null);
    }, []);
    const getPreSelectedDealerId = useCallback(() => {
        if (activePreferDealerId) {
            return activePreferDealerId;
        }
        return head(dealers)?.vicinityId;
    }, [dealers, activePreferDealerId]);
    const MapModalComponent = isDesktop ? MapModalDesktop : MapModalMobile;
    return (React.createElement(MapModalComponent, { dealers: isOnlyCachedDealer ? [] : dealers, selectedDealerId: selectedDealerId, preselectedDealerId: getPreSelectedDealerId(), myLocation: myLocation, googleApiKey: googleApiKey, searchInitialValue: searchInitialValue, isRightToLeft: isRightToLeft, handleMapInfoWindowDismiss: handleMapInfoWindowDismiss, submitDealer: submitDealer, setSelectedDealerId: setSelectedDealerId, isHiddenCloseIcon: true }));
}
